import { render, staticRenderFns } from "./ForceAttribution.vue?vue&type=template&id=2eddb749"
import script from "./ForceAttribution.vue?vue&type=script&lang=js"
export * from "./ForceAttribution.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports